import { Box, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface BalanceSheetSkeletonProps {
  /** Stacks the sections regardless of viewport width, for the half-width
   * widget slot (IU-245). */
  stacked?: boolean;
}

const PLACEHOLDER_ROWS = Array.from({ length: 5 }, (_, index) => index);

const SkeletonSection = ({ section }: { section: string }) => (
  <Box flex={1}>
    <Box mb={2}>
      <Typography variant='h5'>
        <Skeleton width={150} />
      </Typography>
    </Box>
    <Box>
      <Box
        sx={{
          mb: 2,
          height: 40,
          bgcolor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.08)'
              : theme.palette.grey[100],
        }}
      />

      {PLACEHOLDER_ROWS.map((index) => (
        <Box
          key={`${section}-${String(index)}`}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            py: 1.5,
            borderBottom: '1px solid rgba(224, 224, 224, 0.2)',
          }}
        >
          <Skeleton width='40%' />
          <Box sx={{ display: 'flex', gap: 4 }}>
            <Skeleton width={80} />
            <Skeleton width={100} />
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

const BalanceSheetSkeleton: React.FC<BalanceSheetSkeletonProps> = ({
  stacked = false,
}) => {
  const theme = useTheme();
  // NOTE: in our theme `sm` is 800px.
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box p={{ xs: 2 }}>
      <Box
        display='flex'
        flexDirection={isMobile || stacked ? 'column' : 'row'}
        justifyContent='space-between'
        gap={4}
      >
        <SkeletonSection section='asset' />
        <SkeletonSection section='liability' />
      </Box>
    </Box>
  );
};

export default BalanceSheetSkeleton;
